/**
 * Fallback titles for routes that do not set their own <title> via Helmet.
 */
export default function getPageTitleFromPath(
  pathname: string
): string | undefined {
  if (pathname.startsWith("/feed")) {
    return "Explore";
  }
  if (pathname.startsWith("/search")) {
    return "Search";
  }
  if (pathname.startsWith("/account/edit/layout")) {
    return "Edit Profile Layout";
  }
  if (pathname.startsWith("/account/edit/profile")) {
    return "Edit Profile";
  }
  if (pathname.startsWith("/account/edit/account")) {
    return "Edit Account";
  }
  if (pathname.startsWith("/account/edit/password")) {
    return "Update Password";
  }
  if (pathname.startsWith("/account")) {
    return "Settings";
  }
  if (pathname.startsWith("/teams/create")) {
    return "Create Team";
  }
  if (pathname.startsWith("/project/full-page")) {
    return "Project";
  }
  if (pathname.startsWith("/project/details")) {
    return "Project";
  }
  if (pathname.startsWith("/team-project")) {
    return "Team Project";
  }
  if (pathname.startsWith("/projects/")) {
    return "Edit Project";
  }
  if (pathname.startsWith("/team-projects/")) {
    return "Edit Team Project";
  }
  if (/^\/teams\/[^/]+\/manage/.test(pathname)) {
    return "Manage Team";
  }
  if (/^\/teams\/[^/]+$/.test(pathname)) {
    return "Team";
  }
  if (/^\/user\/[^/]+/.test(pathname)) {
    return "Profile";
  }

  return undefined;
}
